import type { EventBusKey } from "@vueuse/core";

export type TourBusEvent = { type: "reset-editor" };
export const tourEventKey: EventBusKey<TourBusEvent> = Symbol("tour-event-key");
